import { useI18n } from "../../lib/i18n.jsx";
import { Link } from "react-router-dom";
import { Sun, Snowflake, ArrowRight } from "lucide-react";

export default function Picker() {
  const { t } = useI18n();

  const cards = [
    {
      to: "/lato",
      img: "/img/summer.webp",
      season: t.picker.summer.season,
      title: t.picker.summer.title,
      body: t.picker.summer.body,
      cta: t.picker.summer.cta,
      Icon: Sun,
      bgClass: "bg-summer-50",
      borderClass: "border-summer/30",
      tagBg: "bg-summer",
      tagText: "text-cream",
      btnClass: "btn-pill-primary",
      testid: "picker-card-summer"
    },
    {
      to: "/zima",
      img: "/img/winter.webp",
      season: t.picker.winter.season,
      title: t.picker.winter.title,
      body: t.picker.winter.body,
      cta: t.picker.winter.cta,
      Icon: Snowflake,
      bgClass: "bg-winter-50",
      borderClass: "border-winter/20",
      tagBg: "bg-winter",
      tagText: "text-cream",
      btnClass: "btn-pill-winter",
      testid: "picker-card-winter"
    }
  ];

  return (
    <section
      id="camps"
      data-testid="picker-section"
      className="bg-cream py-20 md:py-28"
    >
      <div className="max-w-[1300px] mx-auto px-5 md:px-8">
        <div className="text-center mb-12 md:mb-16">
          <p className="font-handwritten text-summer text-2xl md:text-3xl mb-2">
            {t.picker.kicker}
          </p>
          <h2
            className="font-display font-bold text-winter leading-tight"
            style={{ fontSize: "clamp(2rem, 4.5vw, 3.5rem)" }}
          >
            {t.picker.title}
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {cards.map((c) => (
            <Link
              key={c.to}
              to={c.to}
              data-testid={c.testid}
              className={`card-soft overflow-hidden ${c.borderClass} block`}
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={c.img}
                  alt={c.title}
                  className="absolute inset-0 w-full h-full object-cover"
                />
                <div className={`absolute top-4 left-4 ${c.tagBg} ${c.tagText} sticker`}>
                  <c.Icon className="w-3.5 h-3.5" />
                  {c.season}
                </div>
              </div>
              <div className={`p-6 md:p-8 ${c.bgClass}`}>
                <h3 className="font-display font-bold text-winter text-2xl md:text-3xl leading-tight mb-3">
                  {c.title}
                </h3>
                <p className="text-winter/70 mb-6">{c.body}</p>
                <span className={`btn-pill ${c.btnClass}`}>
                  {c.cta} <ArrowRight className="w-4 h-4" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
